import script from "./horizontalIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./horizontalIndex.vue?vue&type=script&setup=true&lang=js"

import "./horizontalIndex.vue?vue&type=style&index=0&id=0c98831a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c98831a"]])

export default __exports__